const CACHE = "THEATER-FLORA"


export async function getCachedAsset(url: string) {
  const cache = await caches.open(CACHE)
  let asset = await cache.match(url)
  if( ! asset ) {
    asset = await cacheAsset(url)
  }

  return asset
}


async function cacheAsset(url:string) {
  const cache = await caches.open(CACHE)
  const response = await fetch(url)

  cache.put(url, response.clone())

  return response
}


async function deleteAllCache() {
  return await caches.delete(CACHE)
}


export class CacheContext {
  deleteAllCache = deleteAllCache
  getCachedAsset = getCachedAsset
  cacheAsset = cacheAsset

  constructor() {
    return this
  }
}